/* Printables (m11 #4) — the studioCloud/desktop Printables browser (components/printables, copied; see FORK.md)
   on brightivity.dev/printables: landing + featured collections, category + curriculum trees, region/curriculum/
   language filters, search, sorts, similar strip, standards, buy (credits) → My library, Print. */
import { TopBar } from '../app/AppShell.jsx';
import Printables from '../components/printables/Printables.jsx';
import '../features/printables/printables.css';
import { useTranslation } from 'react-i18next';

export default function PrintablesPage() {
  const { t } = useTranslation('bv');
  return (
    <div className="bv-content bv-printables-page" data-testid="printables-page">
      <TopBar title={t('nav.printables')} subtitle={t('tool.printables.subtitle')} />
      <div className="bv-printables-page__body"><Printables /></div>
    </div>
  );
}
